/*
 * Einblend-Animationen (Hero und .js-scroll-activate), Stand 27.09.2026, Local Peak.
 * Vorher hing das Skript an jQuery. Auf Seiten ohne jQuery (Produkt, Kollektion)
 * brach es ab, und die Texte blieben unsichtbar. Jetzt ohne jQuery, gleiche
 * Animationen mit anime.js, gleiche Schwellen (300 px Desktop, 150 px Mobil).
 * Fehlt anime.js, werden die Elemente ohne Animation sichtbar.
 */
(function () {
  var hasAnime = typeof window.anime === 'function';

  function sichtbar(el) {
    el.style.opacity = 1;
    el.style.transform = 'none';
  }

  function heroAnimation() {
    var bilder = document.querySelectorAll('.js-hero-content-image');
    var texte = document.querySelectorAll('.js-hero-content');
    if (!bilder.length && !texte.length) return;
    /* Der Hero (sections/arHero.liquid) blendet seit 27.09.2026 per CSS ein. */
    if (document.querySelector('.arHero .js-hero-content-image')) return;
    if (!hasAnime) {
      bilder.forEach(sichtbar);
      texte.forEach(sichtbar);
      return;
    }
    var tl = window.anime.timeline({ easing: 'easeInOutSine', duration: 1000 });
    if (bilder.length) tl.add({ targets: '.js-hero-content-image', opacity: [0, 1], translateY: [500, 0] });
    if (texte.length) tl.add({ targets: '.js-hero-content', opacity: [0, 1], translateY: [300, 0] });
  }

  function schwelle(el) {
    if (window.innerWidth <= 767) return 150;
    var eigen = el.getAttribute('data-offset');
    return eigen !== null && eigen !== '' ? parseInt(eigen, 10) || 0 : 300;
  }

  function aufdecken(el) {
    var einzeln = el.classList.contains('js-scroll-activate--individual');
    el.classList.remove('js-scroll-activate');
    if (!hasAnime) {
      sichtbar(el);
      el.querySelectorAll('.js-scroll-individual').forEach(sichtbar);
      return;
    }
    if (einzeln) {
      window.anime({
        targets: el.querySelectorAll('.js-scroll-individual'),
        opacity: [0, 1],
        easing: 'easeInOutSine',
        duration: 500,
        delay: window.anime.stagger(200)
      });
    } else {
      window.anime({
        targets: el,
        opacity: [0, 1],
        translateY: [100, 0],
        easing: 'easeInOutSine',
        duration: 1000
      });
    }
  }

  function scrollActivate() {
    var unten = window.scrollY + window.innerHeight;
    document.querySelectorAll('.js-scroll-activate').forEach(function (el) {
      var oben = el.getBoundingClientRect().top + window.scrollY + schwelle(el);
      if (unten > oben) aufdecken(el);
    });
  }

  var angefordert = false;
  function geplant() {
    if (angefordert) return;
    angefordert = true;
    window.requestAnimationFrame(function () {
      angefordert = false;
      scrollActivate();
    });
  }

  function initializePageAnimations() {
    heroAnimation();
    scrollActivate();
    if (typeof window.Rellax === 'function' && document.querySelector('.rellax')) {
      new window.Rellax('.rellax', { speed: -2.5, center: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePageAnimations, { once: true });
  } else {
    initializePageAnimations();
  }

  window.addEventListener('scroll', geplant, { passive: true });
  window.addEventListener('resize', geplant, { passive: true });
  window.addEventListener('load', geplant);
  /* Theme-Editor: neu geladene Sektionen bekommen ihre Animation. */
  document.addEventListener('shopify:section:load', geplant);
  /* Sicherheitsnetz: nach 5 s wird alles gezeigt, was noch versteckt ist. */
  window.setTimeout(function () {
    document.querySelectorAll('.js-scroll-activate').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) aufdecken(el);
    });
  }, 5000);
})();
